import React from 'react';
import { BrowserRouter as Router, Route, Link, Redirect } from "react-router-dom";
import VideoList from "./components/VideoList";
import VideoEditor from "./components/VideoEditor";
import VideoNew from "./components/VideoNew";
import VideoExporter from "./components/VideoExporter";
import LogIn from "./components/LogIn";
import Register from "./components/Register";
import firebase from './Firebase';
import './App.css';


function LoggedInRouter() {
  return (
    <Router>
      <div className="wrapper">
        <nav className="navbar">
          <ul>
            <li>
              <Link to="/videos">List</Link>
            </li>
            <li>
              <Link to="/my-videos-new">New</Link>
            </li>
          </ul>
        </nav>
        <div className="nav-content">
          <Route path="/videos" component={VideoList} />
          <Route path="/my-videos-new/" component={VideoNew} />
          <Route path="/my-videos-edit/:vid" component={VideoEditor} />
          <Route path="/my-videos-export/:vid" component={VideoExporter} />
        </div>
      </div>
    </Router>
  );
}


class AppRouter extends React.Component {

  constructor(props){
    super(props);
    this.props = props;
    this.state = {loggedIn: false}
  }

  render() {
    return (
      <Router>
        <Route path="/" exact component={LogIn} />
        <Route path="/register" component={Register} />
        <Route path="/videos" component={LoggedInRouter} />
      </Router>
    )
  }
}

export default AppRouter;
